/**
 * Encoding conversion table for JIS to UTF-8
 */
var JIS_TO_UTF8_TABLE = null;
module.exports = JIS_TO_UTF8_TABLE;



//////////////////
// WEBPACK FOOTER
// ../~/encoding-japanese/src/jis-to-utf8-table.js
// module id = 608
// module chunks = 0